import React from 'react';
import styles from './OrderNotesBanner.module.css';

interface OrderNotesBannerProps {
  notes: string;
}

export const OrderNotesBanner: React.FC<OrderNotesBannerProps> = ({ notes }) => {
  return (
    <div className={styles.banner}>
      <p className={styles.title}>⚠️ Order Notes</p>
      <p className={styles.body}>{notes}</p>
    </div>
  );
};
